// extracted by mini-css-extract-plugin
export var accordion = "accordion-module--accordion--q8Bo9";
export var header = "accordion-module--header--OPLu5";
export var leftText = "accordion-module--leftText--Mo--K";
export var rightText = "accordion-module--rightText--owcL+";
export var chevron = "accordion-module--chevron--u434h";
export var rotate = "accordion-module--rotate--IsmA7";
export var content = "accordion-module--content--UgIjt";
export var icon = "accordion-module--icon--1IxQE";
export var selected = "accordion-module--selected--ucdFH";